import React, { useState, useEffect, Fragment } from "react";
import SimpleModal from "../../components/Modals/simple-modal";
import RequestKeyModal from "../../components/Modals/request-key-modal";
import EnterKeyModal from "../../components/Modals/enter-key-modal";
import { checkAccessKey, createAccessKeyRequest } from "../../api";
import Loader from "../../components/Modals/loader-modal";
import CongratulationModal from "../../components/Modals/congratulation-modal";
import moment from "moment";

const Login = ({ setShowLanding }) => {
  const [activeModal, setActiveModal] = useState("accessKey");
  const [loading, setLoading] = useState(false);
  const checkKey = async key => {
    if (key) {
      setLoading(true);
      const data = await checkAccessKey("mailService/mails/checkKey", { key });
      if (data && data.success) {
        setLoading(false);
        setShowLanding(true);
      } else {
        setLoading(false);
        setActiveModal("enterKey");
      }
      return data;
    } else {
      setActiveModal("enterKey");
    }
    return null;
  };

  useEffect(() => {
    const localStorage = window.localStorage;
    const keyWithDate = JSON.parse(localStorage.getItem("accessKey"));

    if (
      keyWithDate &&
      keyWithDate.expirationDate &&
      keyWithDate.expirationDate >
        moment()
          .utc()
          .valueOf()
    ) {
      checkKey(keyWithDate && keyWithDate.key);
    } else {
      setActiveModal("enterKey");
      localStorage.removeItem("accessKey");
      setLoading(false);
    }
  }, []);

  const createAccessKey = async data => {
    setLoading(true);
    const res = await createAccessKeyRequest(
      "mailService/mails/createKey",
      data
    );

    setActiveModal("congratulation");
    setLoading(false);
  };

  const renderActiveModal = () => {
    switch (activeModal) {
      case "enterKey":
        return (
          <EnterKeyModal setActiveModal={setActiveModal} checkKey={checkKey} />
        );
        break;
      case "requestKey":
        return (
          <RequestKeyModal
            setActiveModal={setActiveModal}
            createAccessKey={createAccessKey}
          />
        );
        break;
      case "congratulation":
        return <CongratulationModal setActiveModal={setActiveModal} />;
        break;
      default:
    }
  };

  return (
    <Fragment>
      <Loader isLoading={loading} />
      <SimpleModal open={activeModal && !loading} hideModal={() => {}}>
        {renderActiveModal()}
      </SimpleModal>
    </Fragment>
  );
};

export default Login;
